/**
 * Web Style Import
 *
 */

import './style/dnb-dialog.scss'
